export const initCSSMarquee = () => {

	const pixelsPerSecond = 40;
	const marquees = document.querySelectorAll('[data-css-marquee]');

	if (!marquees.length) return () => {}

	// Duplicate each [data-css-marquee-list] element inside its container
	marquees.forEach(marquee => {
		marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
			const duplicate = list.cloneNode(true)
			marquee.appendChild(duplicate)
		})
	})

	// Create an IntersectionObserver to check if the marquee container is in view
	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			entry.target.querySelectorAll('[data-css-marquee-list]').forEach(list =>
				list.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused'
			)
		})
	}, { threshold: 0 })

	// Set the animation duration from the list's width, and again whenever that width changes.
	// The stylesheet loads async, so Safari can run this before the CSS applies and the first width is wrong.
	const resizeObserver = new ResizeObserver(entries => {
		entries.forEach(entry => {
			const width = entry.target.offsetWidth
			if (width) entry.target.style.animationDuration = (width / pixelsPerSecond) + 's'
		})
	})

	marquees.forEach(marquee => {
		marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
			list.style.animationPlayState = 'paused'
			resizeObserver.observe(list)
		})
		observer.observe(marquee)

		marquee.addEventListener('mouseenter', () => {
			marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
				list.style.animationPlayState = 'paused'
			})
		})
	
		marquee.addEventListener('mouseleave', () => {
			marquee.querySelectorAll('[data-css-marquee-list]').forEach(list => {
				list.style.animationPlayState = 'running'
			})
		})
	})

	return () => {
		observer.disconnect()
		resizeObserver.disconnect()
	}

}